import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import { Card } from 'baseui/card';

import { CardItem, AppBarLayout } from 'commons-ui';

import AppSelect from './components/AppSelect';
import useMenuItems from './useMenuItems';

const Home: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { menuItems } = useMenuItems();

	return (
		<>
			<AppBarLayout />
			<div
				className={css({
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-evenly',
					alignItems: 'center',
					height: 'calc(100% - 60px)'
				})}>
				<AppSelect />
				{menuItems.map((item) => {
					return item.isEnabled() ? (
						<div
							key={item.label}
							className={css({
								height: '130px',
								width: '70%',
								cursor: 'pointer'
							})}
							role='button'
							tabIndex={0}
							onClick={(e) => {
								e.preventDefault();
								history.push(item.url);
							}}>
							<Card
								overrides={{
									Root: {
										style: () => ({
											width: '100%',
											height: '100%'
										})
									},
									Body: {
										component: () => <CardItem label={item.label} img={item.img} />
									}
								}}
							/>
						</div>
					) : null;
				})}
			</div>
		</>
	);
};

export default Home;
